import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { StockLevelMonitoringTemplateCompanyLinkModel } from '../../../../../../models/aggregates/erp/stock/stock-level-monitoring-template-company-link.model';

@Injectable({ providedIn: 'root' })
export class StockLevelMonitoringTemplateCompanyLinkService extends BaseApiTemplateService<StockLevelMonitoringTemplateCompanyLinkModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-template-company-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-template-company-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-level-monitoring-template-company-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = theHttp;
  }

}
